import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../common/BaseComponent';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html'
})

export class SessionTimeoutComponent extends BaseComponent implements OnInit {

  constructor(
    injector: Injector
  ) {
    super(injector);
    this.menuService.setDisplayStatusByMenuType("noauth");
  }

  ngOnInit(): void { 
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("loginEmail");
    sessionStorage.removeItem("resource_url");
    sessionStorage.removeItem("backUrl");
  }

  onSubmit() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("loginEmail");
    sessionStorage.removeItem("resource_url");
    sessionStorage.removeItem("backUrl");

    const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getLogoutSuccessUri();
    window.location.href = redirectUrl;

  }
}
